import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNoobookContext } from '../context/NoobookContext';
import styled from 'styled-components';
//import { LiaBookMedicalSolid } from 'react-icons/lia';
import { useNavigate } from 'react-router-dom';
import { PiBooksFill } from 'react-icons/pi';
import { IoClose, IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { FiTrash2, FiEdit2, FiChevronRight } from 'react-icons/fi';
import { getAccessToken } from '../react-queries/queries';
import { getBookcaseList, getBookcaseBooks, createBookcase, modifyBookcase, deleteBookcase, deleteBookcaseBook } from '../api/BookcaseApi';
import { processApiResponse } from '../common/errorMessage';
import LoadingOverlay from '../components/LoadingOverlay';
import { FaTimes } from 'react-icons/fa';
import NupilBookDetailPage from './NupilBookDetailPage';
import BookDetailPage from './BookDetailPage';
import BookCoverImage from '../components/BookCoverImage';



const NUDOK = 'NUDOK';
const NUPIL = 'NUPIL';

const PAGE_SIZE = 30;


const AddBookModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const AddBookModalContent = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  width: 90%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AddBookModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: normal;
  margin: 0 0 24px;
  width: 100%;
  text-align: left;
`;

const Input = styled.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  font-size: 16px;
  margin-bottom: 24px;
  text-align: center;
  &::placeholder {
    color: #bbb;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 8px;
`;

const CheckboxItem = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
`;

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

const CheckboxHint = styled.div`
  width: 100%;
  margin-bottom: 24px;
  font-size: 12px;
  line-height: 1.4;
  color: #888;
`;



const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
`;

const ModalButton = styled.button`
  border: none;
  border-radius: 8px;
  padding: 10px 40px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;

  &.cancel {
    background-color: #ccc;
    color: white;
  }

  &.confirm {
    background-color: #1976d2;
    color: white;
  }
`;

const SearchContainer = styled.div`
  padding: 16px 20px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
`;

const SearchLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
`;

const SearchInputContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const SearchInput = styled.input`
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 16px;
  outline: none;
  
  &:focus {
    border-color: #1976d2;
  }
  
  &::placeholder {
    color: #999;
  }
`;

const SearchButton = styled.button`
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  
  &:hover {
    background: #1565c0;
  }
`;

// -- Full Screen Book List Modal --
const FullScreenModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  max-width: 480px; /* To match the main app layout on larger screens */
  margin: 0 auto;
`;

const ModalHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
`;

const ModalTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FullScreenModalTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
`;

const ModalActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const AddBookButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  font-size: 1rem;
  color: #555;
  cursor: pointer;
`;

const BookGrid = styled.div`
  
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 20px;
`;


const DeleteButton = styled.button`
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: rgba(158, 158, 158, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(117, 117, 117, 1);
    transform: scale(1.1);
  }
`;


const ModalFooter = styled.footer`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;
`;

const PaginationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #666;
`;

const CurrentPage = styled.span`
  font-weight: bold;
  color: #333;
`;

const TotalPages = styled.span`
  color: #999;
`;

const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const PageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #e0e0e0;
  background: ${props => props.disabled ? '#f8f9fa' : '#fff'};
  border-radius: 50%;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  color: ${props => props.disabled ? '#d0d0d0' : '#888'};
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #f0f0f0;
    border-color: #ccc;
    transform: scale(1.05);
  }
  
  &:active:not(:disabled) {
    transform: scale(0.95);
  }
`;

const ScrollBar = styled.div`
  width: 200px;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  position: relative;
  cursor: pointer;
`;

const ScrollThumb = styled.div`
  position: absolute;
  left: ${props => props.position}%;
  top: 0;
  width: 20%;
  height: 100%;
  background: #555;
  border-radius: 2px;
  transition: left 0.2s ease;
`;


const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;


/*
const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;
*/


const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;


const BookDetailModal = ({bookId, onClose, selectedTab}) => {
  const [modified, setModified] = useState(false);
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>상세 보기</ModalTitle>
        <ModalCloseButton onClick={()=>{onClose(modified);}}>
          <FaTimes />
        </ModalCloseButton>
      </ModalHeader>
      <ModalContent>
        {selectedTab === NUDOK 
        ? <BookDetailPage propBookId={bookId} onClose={onClose} onModified={()=>setModified(true)} /> 
        : <NupilBookDetailPage propBookId={bookId} onClose={onClose} onModified={()=>setModified(true)} />}
      </ModalContent>
    </Modal>
  )
};




const BookListModal = ({ category, onClose , onNextPage, onDeleteBook, onBookClick}) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  const { bookcaseId, title, count, books } = category??{bookcaseId:0, title:'', count:0, books:[]};

  const booksPerPage = 12; // 4열 x 3행
  const totalBooks = count; // 예시 총 책 수
  const totalPages = Math.ceil(totalBooks / booksPerPage);

  const handleDeleteBook = async (book) => {
    onDeleteBook(book);
  };

  useEffect(() => {
    if( books.length < totalBooks && currentPage * booksPerPage >= books.length - 2) {
      onNextPage();
    }
  }, [currentPage]);


  const groupBooks = (books, groupSize) => {
    const groups = [];
    for (let i = 0; i < books.length; i += groupSize) {
      groups.push(books.slice(i, Math.min(i + groupSize, books.length)));
    }
    return groups;
  }


  
  
  
  //const displayBooks = [...books];

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleScrollBarClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const percentage = (clickX / rect.width) * 100;
    const newPage = Math.ceil((percentage / 100) * totalPages);
    setCurrentPage(Math.max(1, Math.min(totalPages, newPage)));
  };

  const scrollThumbPosition = ((currentPage - 1) / (totalPages - 1)) * 80; // 80%는 스크롤바의 이동 가능 범위

  return (
    <FullScreenModalWrapper>
      <ModalHeader>
        <ModalTitleContainer>
          <FullScreenModalTitle>{title} ({count})</FullScreenModalTitle>
        </ModalTitleContainer>
        <ModalActions>
          <IoClose size={28} onClick={onClose} style={{ cursor: 'pointer' }} />
        </ModalActions>
      </ModalHeader>
        {
          groupBooks(books, booksPerPage).filter((group, index) => (index + 1)=== currentPage).map((group, index) => (
            <BookGrid key={`${index}`}>
              {group.map((book, index) => (
                <div key={`${book.idx}-${index}`} style={{ position: 'relative', height: '140px' }}>
                  <BookCoverImage
                    src={book.cover}
                    alt={book.title}
                    width="100%"
                    height={140}
                    borderRadius={4}
                    boxShadow="none"
                    fontSize={11}
                    onClick={(e) => onBookClick(book)}
                  />
                  <DeleteButton onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteBook(book);
                  }}>
                    <FiTrash2 size={12} />
                  </DeleteButton>
                </div>
              ))}
            </BookGrid>
          ))
        }
      <ModalFooter>
        <PaginationControls>
          <PageButton 
            onClick={handlePrevPage} 
            disabled={currentPage === 1}
          >
            <IoChevronBack size={24} />
          </PageButton>
          <ScrollBar onClick={handleScrollBarClick}>
            <ScrollThumb position={scrollThumbPosition} />
          </ScrollBar>
          <PageButton 
            onClick={handleNextPage} 
            disabled={currentPage === totalPages}
          >
            <IoChevronForward size={16} />
          </PageButton>
        </PaginationControls>
        <PaginationInfo>
          <CurrentPage>{currentPage}</CurrentPage>
          <span>/</span>
          <TotalPages>{totalPages}</TotalPages>
        </PaginationInfo>
      </ModalFooter>
    </FullScreenModalWrapper>
  );
};

const Wrapper = styled.div`
  background: #fff;
  min-height: 100vh;
  padding: 0 0 80px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 16px;
`;

const TabToggle = styled.div`
  display: flex;
  gap: 8px;
`;

const TabBtn = styled.button`
  background: ${({ active }) => (active ? '#222' : '#f0f0f0')};
  color: ${({ active }) => (active ? '#fff' : '#888')};
  border: none;
  border-radius: 18px;
  font-size: 1rem;
  font-weight: 500;
  padding: 8px 18px;
  cursor: pointer;
  transition: background 0.2s;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  font-size: 1rem;
  color: #555;
  cursor: pointer;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  margin: 0 20px;
`;

const Section = styled.section`
  padding: 24px 0;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 16px;
`;

const SectionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MoreBtn = styled.button`
  background: none;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0;
  color: #999;
  font-size: 13px;
  line-height: 1;

  &:hover {
    color: #777;
  }
`;

const MoreCircle = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ddd;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const SectionTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
`;

const BookListContainer = styled.div`
  position: relative;
  padding: 0 20px;
`;

const BookList = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding-bottom: 16px; 
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BookItem = styled.div`
  flex-shrink: 0;
  width: 110px;
`;

const Pagination = styled.div`
  text-align: right;
  font-size: 0.9rem;
  color: #888;
  margin-top: -8px; 
  padding-right: 20px;
`;

const BookCategory = ({ title, count, books, onNextPage, onPlusClick, onEditClick, onDeleteClick, onBookClick, isDefault }) => {
  const bookListRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleScroll = useCallback(() => {
    if (!bookListRef.current || isLoading) return;

    const { scrollLeft, scrollWidth, clientWidth } = bookListRef.current;
    const scrollPosition = scrollLeft + clientWidth;
    const threshold = scrollWidth - 100; // 끝에서 100px 전에 로드

    if (scrollPosition >= threshold) {
      if(isLoading) {
        return;
      }
      if(onNextPage) {
        setIsLoading(true);
        onNextPage().finally(() => {
          setIsLoading(false);
        });
      }
    }
  }, [onNextPage, isLoading]);

  useEffect(() => {
    const bookList = bookListRef.current;
    if (bookList) {
      bookList.addEventListener('scroll', handleScroll);
      return () => bookList.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);
      

  useEffect(() => {
    const bookList = bookListRef.current;
    if (bookList) {
      bookList.addEventListener('scroll', handleScroll);
      return () => bookList.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  return (
    <Section>
      <SectionHeader>
        <SectionTitleContainer>
          <SectionTitle>{title}</SectionTitle>
          <span>({count})</span>
          <MoreBtn type="button" onClick={onPlusClick} aria-label={`${title} 더보기`}>
            <MoreCircle>
              <FiChevronRight size={12} />
            </MoreCircle>
            더보기
          </MoreBtn>
          {!isDefault && (
            <>
              <FiEdit2 size={16} color="#bbb" style={{ cursor: 'pointer' }} onClick={onEditClick} />
              <FiTrash2 size={16} color="#bbb" style={{ cursor: 'pointer' }} onClick={onDeleteClick} />
            </>
          )}
        </SectionTitleContainer>
      </SectionHeader>
      <BookListContainer>
        <BookList ref={bookListRef}>
          {books.map(book => (
            <BookItem key={book.bookId} onClick={(e)=>onBookClick(book)}>
              <BookCoverImage
                src={book.cover}
                alt={book.title}
                width="100%"
                height={160}
                borderRadius={4}
                boxShadow="0 2px 4px rgba(0,0,0,0.1)"
                marginBottom={8}
                fontSize={12}
              />
            </BookItem>
          ))}
          {isLoading && (
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              padding: '20px',
              color: '#666',
              fontSize: '14px'
            }}>
              <LoadingOverlay />
            </div>
          )}
        </BookList>
      </BookListContainer>
      <Pagination> {Math.ceil(books.length / PAGE_SIZE)} / {Math.ceil(count / PAGE_SIZE)}</Pagination>
    </Section>
  );
};

export function MyLibraryPage() {
  const [selectedTab, setSelectedTab] = useState(NUDOK);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [bookcaseList, setBookcaseList] = useState([]);
  const [bookcaseMap, setBookcaseMap] = useState(new Map());
  const [searchTitle, setSearchTitle] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [modalInput, setModalInput] = useState('');
  const [forReading, setForReading] = useState(false);
  const [forScript, setForScript] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editModalInput, setEditModalInput] = useState('');
  const [editingBookcase, setEditingBookcase] = useState(null);
  const [selBookId, setSelBookId] = useState(null);
  const [showBookDetailModal, setShowBookDetailModal] = useState(false);
 
  const navigate = useNavigate();
  const { showBack, setShowBack , logoText, setLogoText, onBookRegistered, setOnBookRegistered } = useNoobookContext();


  const handleOpenBookListModal = (category) => {
    setSelectedCategory(category);
  };

  const handleCloseBookListModal = () => {
    const { bookcaseId } = selectedCategory;
    bookcaseMap.delete(bookcaseId);
    loadNextPage(bookcaseId);
    setSelectedCategory(null);
  };

  const handleBookClick = (book) => {
    //navigate(selectedTab===NUDOK?`/book/${book.bookId}`:`/book-nupil/${book.bookId}`);
    popupBookDetail(book.bookId);
  };

  const handleDeleteBook = async (book) => {
    if (window.confirm(`'${book.title}'을 삭제하시겠습니까?`)) {
      try {
        const { bookcaseId, count,books } = selectedCategory;
        const { accessToken } = await getAccessToken();
        const response = await deleteBookcaseBook(accessToken || '', bookcaseId, book.bookId);
        const processedResponse = processApiResponse(response);
        
        if (processedResponse.success) {
          // 성공적으로 삭제되면 모달을 닫고 목록을 새로고침
          //onClose();
          // 부모 컴포넌트에서 목록 새로고침을 위해 window.location.reload() 사용
          //window.location.reload();
          books.splice(books.indexOf(book), 1);
          setSelectedCategory({...selectedCategory, count:count-1, books:books});
        } else {
          alert(processedResponse.errorMessage || '책 삭제에 실패했습니다.');
        }
      } catch (error) {
        console.error('책 삭제 중 오류:', error);
        alert('책 삭제 중 오류가 발생했습니다.');
      }
    }
  };

  const handleSearch = () => {
    setSearchTitle(searchInput);
  };

  const handleModalConfirm = async () => {
    if (!modalInput.trim()) {
      alert('책장 이름을 입력해주세요.');
      return;
    }
    if (!forReading && !forScript) {
      alert('누독 또는 누필 중 하나 이상 선택해주세요.');
      return;
    }

    try {
      const { accessToken } = await getAccessToken();
      const response = await createBookcase(accessToken || '', modalInput.trim(), forReading, forScript);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setIsModalOpen(false);
        setModalInput('');
        setForReading(false);
        setForScript(false);
        loadData(); // 책장 목록 새로고침
      } else {
        alert(processedResponse.errorMessage || '책장 생성에 실패했습니다.');
      }
    } catch (error) {
      console.error('책장 생성 중 오류:', error);
      alert('책장 생성 중 오류가 발생했습니다.');
    }
  };

  const handleEditClick = (bookcase) => {
    setEditingBookcase(bookcase);
    setEditModalInput(bookcase.name);
    setIsEditModalOpen(true);
  };

  const handleEditModalConfirm = async () => {
    if (!editModalInput.trim()) {
      alert('책장 이름을 입력해주세요.');
      return;
    }

    try {
      const { accessToken } = await getAccessToken();
      const response = await modifyBookcase(accessToken || '', editingBookcase.id, editModalInput.trim());
      const processedResponse = processApiResponse(response);

      if (processedResponse.success) {
        const newName = editModalInput.trim();
        setBookcaseList(prev => prev.map(b =>
          b.id === editingBookcase.id ? { ...b, name: newName } : b
        ));
        if (selectedCategory?.bookcaseId === editingBookcase.id) {
          setSelectedCategory(prev => ({ ...prev, title: newName }));
        }
        setIsEditModalOpen(false);
        setEditModalInput('');
        setEditingBookcase(null);
      } else {
        alert(processedResponse.errorMessage || '책장 이름 변경에 실패했습니다.');
      }
    } catch (error) {
      console.error('책장 이름 변경 중 오류:', error);
      alert('책장 이름 변경 중 오류가 발생했습니다.');
    }
  };

  const handleDeleteBookcase = async (bookcase) => {
    if (!window.confirm(`'${bookcase.name}' 책장을 삭제하시겠습니까?`)) {
      return;
    }

    try {
      const { accessToken } = await getAccessToken();
      const response = await deleteBookcase(accessToken || '', bookcase.id);
      const processedResponse = processApiResponse(response);

      if (processedResponse.success) {
        setBookcaseList(prev => prev.filter(b => b.id !== bookcase.id));
        bookcaseMap.delete(bookcase.id);
        setBookcaseMap(new Map(bookcaseMap));
        if (selectedCategory?.bookcaseId === bookcase.id) {
          setSelectedCategory(null);
        }
      } else {
        alert(processedResponse.errorMessage || '책장 삭제에 실패했습니다.');
      }
    } catch (error) {
      console.error('책장 삭제 중 오류:', error);
      alert('책장 삭제 중 오류가 발생했습니다.');
    }
  };

  
  const loadData = async () => {
     
      if(loading) return;
      setLoading(true);
      try {
        const { accessToken } = await getAccessToken();
        
        // 책장 목록 로드
        const bookcaseResponse = await getBookcaseList(accessToken || '', selectedTab===NUDOK || null, selectedTab===NUPIL || null);
        const processedBookcaseResponse = processApiResponse(bookcaseResponse);
        
        if (!processedBookcaseResponse.success) {
          //alert(processedBookcaseResponse.errorMessage);
          setErrorMessage(processedBookcaseResponse.errorMessage);
          //navigate(0);
          return;
        }
        const {data} = processedBookcaseResponse;
        (data||[]).forEach(bookcase => {
          //bookcaseMap.set(bookcase.id, {curpage:-1, total:0, books:[]});
          loadNextPage(bookcase.id);
        });
        
        setBookcaseList(data || []);
      } catch (error) {
        console.error('데이터 로드 중 오류:', error);
        //alert('네트워크 오류가 발생했습니다. 다시 시도해 주세요.');
        setErrorMessage('네트워크 오류가 발생했습니다. 다시 시도해 주세요.');
        //navigate(-1);
      } finally {
        setLoading(false);
    }
  };
    

  useEffect(() => {
    const prevShowBack = showBack;
    const prevOnBookRegistered = onBookRegistered;
    const prevLogoText = logoText;
    setShowBack(true);
    setLogoText('내서재');
    setOnBookRegistered(() => () => {
      //alert('onBookRegistered');
      bookcaseMap.clear();
      loadData();
    });
    loadData();
    // eslint-disable-next-line
    return () => {
      setShowBack(prevShowBack);
      setOnBookRegistered(() => prevOnBookRegistered);
      setLogoText(prevLogoText);
    };
  }, []);


  //useEffect(() => {
  //  setShowBack(true);
  //  loadData();
  //}, []);

  useEffect(() => {
    //console.log('bookcaseMap', bookcaseMap);
    bookcaseMap.clear();
    loadData();
  }, [selectedTab, setSelectedTab]);


  useEffect(() => {
    (bookcaseList||[]).forEach(bookcase => {
      bookcaseMap.delete(bookcase.id);
      loadNextPage(bookcase.id);
    });
  }, [searchTitle]);


  const bookcaseLockMap = new Map();
  //const orgBookcaseMap = new Map();

  const loadNextPage = async (bookcaseId) => {
    if(bookcaseLockMap.has(bookcaseId)) {
      return;
    }
    bookcaseLockMap.set(bookcaseId, true);
    try {
    let obj = bookcaseMap.get(bookcaseId);
    if(!obj) {
      obj = {curpage:-1, total:0, books:[]};
      //bookcaseMap.set(bookcaseId, obj);
    }
    const {curpage, total, books} = obj;
    if(total > 0 && books.length>= total) {
      return;
    }

    const {accessToken} = await getAccessToken();
    const response = await getBookcaseBooks(accessToken || '', bookcaseId, searchTitle===''?null:searchTitle, curpage+1, PAGE_SIZE);
    const processedResponse = processApiResponse(response);
    if(!processedResponse.success) {
      //setErrorMessage(processedResponse.errorMessage);
      return;
    }
    const {data, page} = processedResponse;
    const lastIdx = books.length;
    books.push(
      ...data.map((book, idx)=>({bookId:book.bookId, title:book.title, cover:book.cover, idx:lastIdx+idx}))
    );
    bookcaseMap.set(bookcaseId, {curpage:page.current, total:page.total, books:books});
    console.log('bookcaseId', bookcaseId);
    //setBookcaseMap(bookcaseMap);
    setBookcaseMap(new Map(bookcaseMap));
    //return {curpage:page.current, total:page.total, books:books};
    } catch (error) {
      console.error('데이터 로드 중 오류:', error);
    } finally {
      bookcaseLockMap.delete(bookcaseId);
    }
  };

  const popupBookDetail = (bookId) => {
    setSelBookId(bookId);
    setShowBookDetailModal(true);
  };

  const handleBookDetailClose = (modified) => {
    setShowBookDetailModal(false);
    if(modified) {
      bookcaseMap.clear();
      loadData();
    }
  };

  


  return (
    <Wrapper>
      <TabContainer>
        <TabToggle>
          <TabBtn active={selectedTab === NUDOK} onClick={() => setSelectedTab(NUDOK)}>
            누독
          </TabBtn>
          <TabBtn active={selectedTab === NUPIL} onClick={() => setSelectedTab(NUPIL)}>
            누필
          </TabBtn>
        </TabToggle>
        <AddButton onClick={() => setIsModalOpen(true)}>
          <PiBooksFill size={20} />
          책장추가
        </AddButton>
      </TabContainer>
      
      {/* 검색 섹션 */}
      <SearchContainer>
        <SearchLabel>내서재내 책제목 검색</SearchLabel>
        <SearchInputContainer>
          <SearchInput
            type="text"
            placeholder="책 제목을 입력하세요"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <SearchButton onClick={handleSearch}>
            검색
          </SearchButton>
        </SearchInputContainer>
      </SearchContainer>
      
      <Divider />
      {
        loading && (
          //<div>Loading...</div>
         <LoadingOverlay />
        )
      }
      {
        errorMessage && (
          <div>{errorMessage}</div>
        )
      }
      {
        bookcaseList.length > 0 && (
          bookcaseList.map(bookcase => {
          const obj = bookcaseMap.get(bookcase.id);
          const {total, books} = obj??{total:0, books:[]};
      return <BookCategory 
        key={bookcase.id}
        title={bookcase.name} 
        count={total} 
        books={books}
        isDefault={bookcase.isDefault}
        onNextPage={() => loadNextPage(bookcase.id)}
        onBookClick={handleBookClick}
        onEditClick={() => handleEditClick(bookcase)}
        onDeleteClick={() => handleDeleteBookcase(bookcase)}
        onPlusClick={() => handleOpenBookListModal({ bookcaseId: bookcase.id, title: bookcase.name, count: total, books: books })}
      />
     
        }))
      }


      {isEditModalOpen && (
        <AddBookModalBackdrop onClick={() => setIsEditModalOpen(false)}>
          <AddBookModalContent onClick={(e) => e.stopPropagation()}>
            <AddBookModalTitle>책장 이름 수정</AddBookModalTitle>
            <Input
              placeholder="책장 이름을 입력해주세요"
              value={editModalInput}
              onChange={(e) => setEditModalInput(e.target.value)}
            />
            <ButtonContainer>
              <ModalButton className="cancel" onClick={() => setIsEditModalOpen(false)}>취소</ModalButton>
              <ModalButton className="confirm" onClick={handleEditModalConfirm}>확인</ModalButton>
            </ButtonContainer>
          </AddBookModalContent>
        </AddBookModalBackdrop>
      )}

      {isModalOpen && (
        <AddBookModalBackdrop onClick={() => setIsModalOpen(false)}>
          <AddBookModalContent onClick={(e) => e.stopPropagation()}>
            <AddBookModalTitle>새책장</AddBookModalTitle>
            <Input 
              placeholder="새로운 책장 이름 써주세요" 
              value={modalInput}
              onChange={(e) => setModalInput(e.target.value)}
            />
            <CheckboxContainer>
              <CheckboxItem>
                <Checkbox 
                  type="checkbox" 
                  checked={forReading}
                  onChange={(e) => setForReading(e.target.checked)}
                />
                누독
              </CheckboxItem>
              <CheckboxItem>
                <Checkbox 
                  type="checkbox" 
                  checked={forScript}
                  onChange={(e) => setForScript(e.target.checked)}
                />
                누필
              </CheckboxItem>
            </CheckboxContainer>
            <CheckboxHint>※ 누독/누필 중 하나 이상 반드시 선택해주세요.</CheckboxHint>
            <ButtonContainer>
              <ModalButton className="cancel" onClick={() => setIsModalOpen(false)}>취소</ModalButton>
              <ModalButton className="confirm" onClick={handleModalConfirm}>확인</ModalButton>
            </ButtonContainer>
          </AddBookModalContent>
        </AddBookModalBackdrop>
      )}
      
      {
      selectedCategory && (
        <BookListModal
          category={selectedCategory}
          onClose={handleCloseBookListModal}
          onNextPage={() => loadNextPage(selectedCategory.bookcaseId)}
          onDeleteBook={handleDeleteBook}
          onBookClick={handleBookClick}
        />
      )
      }
      {showBookDetailModal && (
        <BookDetailModal bookId={selBookId} onClose={handleBookDetailClose} selectedTab={selectedTab} />
      )}
    </Wrapper>
  );
} 